"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.buscaEnderecoViaCep = void 0;
const vue_1 = __importDefault(require("vue"));
function buscaEnderecoViaCep(cep) {
    let baseUrl = 'https://viacep.com.br/ws/' + cep + '/json/';
    return vue_1.default.$http['get'](baseUrl)
        .then(response => response.data)
        .then((data) => {
        return data;
    });
}
exports.buscaEnderecoViaCep = buscaEnderecoViaCep;
